import logo from './logo.svg';
import logoKnowsMore from './KnowsMore.png';
import logoMickeyGlove from "./MickeyGlove.jpg"
import commentBoxTop from "./CommentBoxTop.svg"
import commentBoxMiddle from "./CommentBoxMiddle.svg"
import commentBoxBottom from "./CommentBoxBottom.svg"
import logoPoweredByKnowsMore from "./PoweredByKnowsMore.png"
import backgroundTopBackgroundGradient from "./top-background-gradient.png"
import logoEncyclopedia from "./Encyclopedia.jpg"
import downloadResume from "./Resume.pdf"
import './App.css';

import ReactGA4 from 'react-ga4';  
import React from 'react'
import { useState, useEffect, useRef, useContext, createContext} from 'react';
import { Button, Input, Label, Container, Message } from 'semantic-ui-react';
import { ItemMeta, ItemImage, ItemHeader, ItemGroup, ItemExtra, ItemDescription, ItemContent, Image, Item } from 'semantic-ui-react';
ReactGA4.initialize('G-GB5572WD00');
ReactGA4.send({ hitType: "pageview", page: "/my-path", title: "Custom Title" });

function Main(){
  const [inputStaticValue, setInputStaticValue] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [logoSpeed, setLogoSpeed] = useState('');
  const [messages, setMessages] = useState([]);
  const messagesEndRef = useRef(null);

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setInputStaticValue(e.target.value);
  };

  const handleClick = () => {
    GetQuote();
    setInputValue('');
    addItem(<div style={parentStyle}><Message style={{ maxWidth: "75%", textAlign: 'left' }}>{inputStaticValue}</Message></div>);
    getTheAnswer();
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      GetQuote();
      setInputValue('');
      addItem(<div style={parentStyle}><Message style={{ maxWidth: "75%", textAlign: 'left' }}>{inputStaticValue}</Message></div>);
      getTheAnswer();
    }
  };

  const addItem = (item) => {
    setMessages((prevMessages) => [...prevMessages, item]);
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth'});
  };

  useEffect(() => {
    scrollToBottom();
  });

  const getTheAnswer = async () => {
    setLogoSpeed('App-logo-spin infinite 2s linear');
    setLoading(true);
    try {
      const response = await fetch(`https://resume.msman.com/api/knowsmore?ask=${inputStaticValue}`);
      const data = await response.text();
      console.log({data});
      addItem(
        <div style={responseStyle.container}>
          <div style={responseStyle.sidebar}>
            <img src={logoEncyclopedia} style={responseStyle.icon}>
            </img>
          </div>
          <div style={responseStyle.content}>
            {data}
          </div>
        </div>
      );
    } catch (error) {
      setError('Error fetching data');
    } finally {
      setLogoSpeed('App-logo-spin infinite 20s linear');
      setLoading(false);
    }
  };

  return (
    <div style={{height: '100%', paddingTop: 75}}>
    <div className='mainContentTop' style={{zIndex: 10, paddingBottom: 0, paddingTop: 5, position: 'fixed', top: 0, minWidth: 'calc(100% - 300px)', minHeight: 135, textAlign:'center', backgroundImage: `url(${backgroundTopBackgroundGradient})`, backgroundRepeat: 'repeat-x'}}><img src={logoPoweredByKnowsMore} style={{height:100}}></img></div>
      <div className='mainContentMiddle' style={{padding: 0}}>
        <div style={{fontSize: 18, lineHeight: 1.3}}>
          {messages.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>
        <div ref={messagesEndRef} style={{paddingBottom: 125}} />
      </div>
      <div className= 'mainContentBottom' style={{paddingBottom: 25, paddingTop: 25, position: 'fixed', bottom: 0, backgroundColor:'#ffffff', minWidth: 'calc(100% - 300px)'}}>
        <div style={{textAlign: 'center'}}>
          <Input
            action={<Button onClick={handleClick}>Send</Button>}            
            placeholder="Message KnowsMore"
            loading={loading}
            style={{ minWidth: '95%', height: '50px', fontSize: 18, lineHeight: 1.3, /*paddingLeft: 30*/}}
            onChange={handleChange}
            onKeyDown={handleEnter}
            value={inputValue}
          />
    </div>
    </div>
  </div>
  );
}

function App()
{
  return (
    <div style={styles.container}>
      <div style={styles.sidebar} className='sidebar'>
        <div style={{textAlign: 'left', display: 'block', lineHeight: 0, minHeight: 150}}>
          <h3 style={{display:'block'}}>Christopher A. Farmer</h3>
          <h4 style={{display:'block', lineHeight: 0}}><a style={{display:'block', lineHeight: 0}} href='https://www.linkedin.com/in/chrisafarmer' target='_blank'>LinkedIn Account</a></h4>
          <h4 style={{display:'block', lineHeight: 0}}><a style={{display:'block', lineHeight: 0}} href='mailto:christopher.farmer@msman.com'>Email Account</a></h4>
          {/*<h4 style={{display:'block', lineHeight: 0}}><a style={{display:'block', lineHeight: 0}} href="public/favicon.ico">Download Resume</a></h4>*/}
        </div>
        <div style={{position: 'fixed', bottom:200, paddingBottom:0, left: 12}}>
          <img src={commentBoxTop} style={commentBoxStyles.commentBoxTop}></img>
          <div style={commentBoxStyles.commentBoxMiddle}><p style={{padding: 10}}>{GetQuote()}</p></div>
          <img src={commentBoxBottom} style={commentBoxStyles.commentBoxBottom}></img>
        </div>
        <div style={{position: 'fixed', bottom:0, paddingBottom:15, left: 37.5}}>
            <img src={logoKnowsMore} style={{width: '175px'}} />
        </div>
      </div>
      <div style={styles.content} className='content'>
        <Main />
      </div>
    </div>
  );
}

function GetQuote(){
    // Step 1: Initialize an array of quotes
    const quotes = [
      "The only limit to our realization of tomorrow is our doubts of today.",
      "Do not wait to strike till the iron is hot; but make it hot by striking.",
      "It is hard to fail, but it is worse never to have tried to succeed.",
      "Success usually comes to those who are too busy to be looking for it.",
      "Don’t be afraid to give up the good to go for the great.",
      "You can also ask anything about Christopher's education, work history or certifications.",
      "This site is constantly being refined. Come back often to see the updates.",
      "This site does not yet chain the conversation, but does maintain an impressive Natural Language Understaning (NLU) characteristic."
    ];
  

    const randomIndex = Math.floor(Math.random() * quotes.length);
    const currentQuote = quotes[randomIndex];

    return (
      currentQuote
    );
}

const styles = {
  container: {
    display: 'flex',
  },
  sidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '250px',
    height: '100vh',
    backgroundColor: '#f9f9f9', //#f9f9f9
    color: '#333',
    padding: '20px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    textAlign: 'center'
  },
  content: {
    marginLeft: '250px',
    padding: '20px',
    backgroundColor: '#fff',
    height: '100vh',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    flex: 1,
  }
};

const parentStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '25px',
  paddingBottom: '25px',
};

const responseStyle = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  sidebar: {
    padding: '5px',
    width: '40px',             // Adjust width to fit your needs
    boxSizing: 'border-box'
  },
  content: {
    whiteSpace: 'preserve',
    paddingLeft: '5px',
    width: '100%',             // Adjust width to fit your needs
    boxSizing: 'border-box',
    flex: 1
  },
  icon: {
    height: '20px'
  }
}

const inputStyle = {
  display: 'flex',
  justifyContent: 'center', // For Flexbox
};

const commentBoxStyles = {
  commentBoxTop: {
    minWidth: 225,
    maxWidth: 225,
    width: 225, 
    display: 'block'
  },
  commentBoxMiddle: {
    backgroundImage: `url(${commentBoxMiddle})`, 
    backgroundRepeat: 'repeat-y',
    //backgroundSize: '225px 5px',
    maxWidth: 225,
    lineHeight: 5,
    //backgroundColor: 'lightblue',
    width: 225,
    display: 'block'
  },
  commentBoxBottom: {
    minWidth: 225,
    maxWidth: 225,
    width: 225,
    height: 45, 
    display: 'block',
    padding: 0,
    lineHeight: 45
    //backgroundColor: 'lightblue',
  }
}

export default App;
